var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { disabled: _vm.isNotDesktop, bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "grid-btn",
                    attrs: { text: "", icon: "", "aria-label": "volume" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", !_vm.value)
                      },
                    },
                  },
                  on
                ),
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "white" : "grey",
                        small: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.value === true ? "apps" : "fas fa-border-all"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v(" Dense Display ")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }